export function listToMap(items: Array<any>, keyName: string) {
  const map = new Map();

  items.forEach((item) => {
    map.set(item[keyName], item);
  });

  return map;
}
